// extracted by mini-css-extract-plugin
export default {"settingsLink":"wcl-account-panel_settingsLink__SbSWl","footerLink":"wcl-account-panel_footerLink__kPKHX","separator":"wcl-account-panel_separator__p8Fc1"};